import { Toast } from 'vant';

function loading(text){
  Toast.loading({
    duration: 0, // 持续展示 toast
    message: text
  });
}
function success(text){
  Toast.success({
    message: text == '' ? '成功': text
  });
}
function fail(text){
  Toast.success({
    message: text == '' ? '失敗': text
  });
}
function text(text){
  Toast({
    //duration: 0,
    message: text,
  });
}
function showToast(text){
  Toast.loading({
    message: text || this.langText("LOADING"),
    forbidClick: true,
    loadingType: 'circular',
    duration:0,//0不消失
    });
}

function close(){
  Toast.clear();
}

export default {
  loading,
  success,
  fail,
  text,
  close,
  showToast
}



// WEBPACK FOOTER //
// ./src/utils/vant.js